export enum OnCallStatus {
  NotOnCall = 'NOTONCALL',
  OnCall = 'ONCALL',
  Idle = 'IDLE',
}

export enum FilterCondition {
  And = 'AND',
  Or = 'OR',
}
